/**
 * Full-screen loading — used only during auth check.
 * Same unified spinner, centered on dark background.
 */
import { Spinner } from './ui';
import { T } from '../styles/tokens';

export function LoadingScreen() {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: T.bg,
      zIndex: 99999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Spinner size="lg" />
    </div>
  );
}
